/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { loadPartnerKnockoutCriteria, evaluatePartnerKnockoutCriteria } from '../actionCreators';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getKnockoutCriteriaIsLoaded, getOfferPartnerKnockoutCriteria } from '../selectors';
import { Grid } from '@mui/material';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DocumentScoringKnockoutCriteriaListContainer from 'features/document/edit/scoring/components/DocumentScoringKnockoutCriteriaListContainer';
import { CollapseCard } from '@totalsoft/rocket-ui';

const KnockoutCriteriaContainer = ({ documentId, siteId, disabled, partnerId, actions, loaded, knockoutCriteria, t }) => {
  const [knockoutCriteriaInProgress, setKnockoutCriteriaInProgress] = useState(false);
  const [cardExpanded, setExpanded] = useState(false);
  const evaluateKnockout = async () => {
    if (partnerId !== null) {
      setKnockoutCriteriaInProgress(true);

      let event = await actions.evaluatePartnerKnockoutCriteria(documentId, siteId, partnerId);
      if (event.ok) {
        await actions.loadPartnerKnockoutCriteria(partnerId);
      }

      setKnockoutCriteriaInProgress(false);
    }
  };

  const onExpand = (_, expanded) => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (cardExpanded && partnerId !== null && !loaded) actions.loadPartnerKnockoutCriteria(partnerId);
  }, [loaded, cardExpanded]);

  return (
    <CollapseCard
      id={'offerPartnerKnockoutCriteriaCard'}
      icon={AssignmentLateIcon}
      title={t('DocumentEdit.Scoring.ScoringGrid.KnockoutCriteria')}
      toggleOnHeaderClick
      expanded={cardExpanded}
      onToggle={onExpand}
    >
      {loaded && knockoutCriteria.knockoutCriteria && (
        <Grid container spacing={1}>
          <DocumentScoringKnockoutCriteriaListContainer
            documentId={documentId}
            siteId={siteId}
            knockoutCriteriaInProgress={knockoutCriteriaInProgress}
            evaluateKnockout={evaluateKnockout}
            documentScoringGridId={knockoutCriteria.documentScoringGridId}
            knockoutCriteriaList={knockoutCriteria.knockoutCriteria}
            disabled={disabled}
            isHistory={false}
            fromPartner={true}
            partnerId={partnerId}
          />
        </Grid>
      )}
    </CollapseCard>
  );
};

KnockoutCriteriaContainer.propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  partnerId: PropTypes.number,
  knockoutCriteria: PropTypes.object,
  loaded: PropTypes.bool.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  disabled: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    knockoutCriteria: getOfferPartnerKnockoutCriteria(state, ownProps.partnerId),
    loaded: getKnockoutCriteriaIsLoaded(state, ownProps.partnerId)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadPartnerKnockoutCriteria, evaluatePartnerKnockoutCriteria }, dispatch),
    dispatch
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(KnockoutCriteriaContainer));
